import React from 'react';
import { checkPermission } from 'HelperFunctions/permissionUtils';
import {
  Team,
  Company,
  Items,
  Export,
  Revenue,
  PriceTag,
  Percentage,
  Profit,
  Receipt,
  Smiley,
  Document,
  Roles,
  QuickbooksCircle,
  TapwiseIcon,
} from 'Components/utils/SvgIcons';

export const divideIntoThreeSubarrays = (array) => {
  let result = [];
  for (let i = 3; i > 0; i--) {
    result.push(array.splice(0, Math.ceil(array.length / i)));
  }
  return result;
};

const reportLinks = (
  multilocationReportsEnabled = false,
  generalLedgerEnabled = false,
  robustAndCustomReports = false,
  quickbooksIntegration = false,
  npsCustomerSurveys = false,
  tapwiseEnabled = false
) => {
  return [
    robustAndCustomReports && {
      icon: <Export />,
      to: '/admin/reports/export',
      id: 'custom_export',
      name: 'Custom Export',
      noMobile: true,
    },
    quickbooksIntegration && {
      icon: <QuickbooksCircle />,
      to: '/admin/reports/quickbooks',
      name: 'QuickBooks',
    },
    {
      icon: <Revenue />,
      to: '/admin/reports/revenue',
      name: 'Revenue',
    },
    {
      icon: <PriceTag />,
      to: '/admin/reports/payments',
      name: 'Payments',
    },
    {
      icon: <Percentage />,
      to: '/admin/reports/salesTax/newSalesTaxReport',
      name: 'Sales Tax',
    },
    {
      icon: <Items />,
      to: '/admin/reports/popularItems',
      name: 'Popular Items',
    },
    {
      icon: <Profit />,
      to: '/admin/reports/profit',
      id: 'profitability',
      name: 'Profitability',
    },
    {
      icon: <Team />,
      to: '/admin/reports/bestCustomers',
      name: 'Best Customers',
    },
    npsCustomerSurveys && {
      icon: <Smiley />,
      to: '/admin/reports/nps',
      id: 'customer_survey',
      name: 'Customer Survey',
    },
    {
      icon: <Document />,
      to: '/admin/reports/documents',
      name: 'Documents',
    },
    {
      icon: <Receipt />,
      to: '/admin/reports/billing',
      id: 'billing_status',
      name: 'Billing Status',
    },
    {
      icon: <Items />,
      to: '/admin/reports/inventory',
      name: 'Inventory',
    },
    {
      icon: <Roles />,
      to: '/admin/reports/staffing',
      name: 'Staffing',
    },
    {
      icon: <Receipt />,
      to: '/admin/reports/total_order_volume',
      name: 'Total Order Volume',
    },
    {
      icon: <Team />,
      to: '/admin/reports/commission',
      name: 'Commission',
    },
    multilocationReportsEnabled && {
      icon: <Company />,
      to: '/admin/reports/multilocation',
      name: 'Multilocation Reports',
    },
    generalLedgerEnabled && {
      icon: <Profit />,
      to: '/admin/reports/generalLedger',
      name: 'General Ledger',
    },
    tapwiseEnabled && checkPermission('view_powerbi_reports') && {
      icon: <TapwiseIcon />,
      to: '/admin/reports/tapwise',
      name: 'TapWise',
    },
  ].filter(Boolean);
};

export const reportLinkColumns = (
  multilocationReportsEnabled = false,
  generalLedgerEnabled = false,
  robustAndCustomReports = false,
  quickbooksIntegration = false,
  npsCustomerSurveys = false,
  tapwiseEnabled = false
) => {
  return divideIntoThreeSubarrays(
    reportLinks(
      multilocationReportsEnabled,
      generalLedgerEnabled,
      robustAndCustomReports,
      quickbooksIntegration,
      npsCustomerSurveys,
      tapwiseEnabled
    )
  );
};
